// extracted by css-extract-rspack-plugin
export default {"CopyButton":"EntityIdCard-module__CopyButton___UN3cw","InfoIcon":"EntityIdCard-module__InfoIcon___ZRWvY"};